import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useLanguageStore } from 'common/src/stores/useLanguageStore';
import { useEffect } from 'react';

export function useTranslation(namespace?: string) {
  const { t, i18n } = useI18nTranslation(namespace);
  const { language } = useLanguageStore();

  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return {
    t,
    changeLanguage: (lang: string) => i18n.changeLanguage(lang),
    currentLanguage: i18n.language,
    isReady: i18n.isInitialized,
  };
}
